import './Stop.css'

export default function StopPopup({ open, title, body, onClose }) {
  if (!open) return null
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <div className="modal-card">
        <h2>{title}</h2>
        <pre className="modal-body">{body}</pre>
        <Card onClick={onClose} aria-label="close" style={{ marginTop: 20 }}>
          close
        </Card>
      </div>
    </div>
  )
}

function Card({ children, onClick}) {
  return (
    <div className="card" onClick={onClick}>
      {children}
    </div>
  )
}
